import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type SectionSpacing = "default" | "tight" | "flush";

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  spacing?: SectionSpacing;
  children?: ReactNode;
}

export const Section = ({ spacing = "default", className, children, ...rest }: SectionProps) => (
  <section
    className={cn("hui-section", spacing !== "default" && `hui-section--${spacing}`, className)}
    {...rest}
  >
    {children}
  </section>
);
